import { render, staticRenderFns } from "./root-admin.vue?vue&type=template&id=dc2d0ffe&scoped=true&"
import script from "./root-admin.vue?vue&type=script&lang=js&"
export * from "./root-admin.vue?vue&type=script&lang=js&"
import style0 from "./root-admin.vue?vue&type=style&index=0&id=dc2d0ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2d0ffe",
  null
  
)

export default component.exports